import type { ADataGridFilter } from "@atiautomacao/ati-ui-library";
import { Storage } from "../../../../../Utils/StorageUtils";
export const ALARM_ADVANCED_FILTERS_KEY = 'alarm_advanced_filters';
export const OVERVIEW_ALARM_CATEGORY_FILTER = 'overviewAlarmCategory';

export type OverviewAlarmCategory = 'CRITICAL' | 'NON_CRITICAL' | 'EQUIPMENT_NO_COMMUNICATION';

const mapOverviewCategoryToFilterState = (
  category: OverviewAlarmCategory
): Pick<FilterState, 'severityName' | 'situationNames'> => {
  switch (category) {
    case 'CRITICAL':
      return {situationNames: ['active'], severityName: ['critical_with_tele_object', 'Urgente']};
    case 'NON_CRITICAL':
      return {situationNames: ['active'], severityName: ['Baixa', 'Média', 'Alta']};
    case 'EQUIPMENT_NO_COMMUNICATION':
      return {situationNames: ['equipment_no_communication'], severityName: []};
    default:
      return {situationNames: [], severityName: []};
  }
};

export const getOverviewAlarmCategoryFromFilters = (
  filters: ADataGridFilter[]
): OverviewAlarmCategory | null => {
  const match = filters.find(
    (filter) => filter.name === OVERVIEW_ALARM_CATEGORY_FILTER && filter.condition === 'equals'
  );
  if (!match?.value) {
    return null;
  }
  const value = String(match.value);
  if (value === 'CRITICAL' || value === 'NON_CRITICAL' || value === 'EQUIPMENT_NO_COMMUNICATION') {
    return value;
  }
  return null;
};

export const getInitialFilterState = (storageKey: string = ALARM_ADVANCED_FILTERS_KEY): FilterState => {
  const stored = Storage.local.get(storageKey, null);
  if (!stored || !Array.isArray(stored)) {
    return { equipmentTypeIds: [], severityName: [], situationNames: [] };
  }
  const storedFilters = stored as ADataGridFilter[];
  const overviewCategory = getOverviewAlarmCategoryFromFilters(storedFilters);
  if (overviewCategory) {
    const mapped = mapOverviewCategoryToFilterState(overviewCategory);
    return {
      equipmentTypeIds: [],
      severityName: mapped.severityName,
      situationNames: mapped.situationNames,
    };
  }

  const state: FilterState = { equipmentTypeIds: [], severityName: [], situationNames: [] };
  storedFilters.forEach((f) => {
    const values = f.value ? String(f.value).split('~').filter(Boolean) : [];
    if (f.name === 'equipmentTypeId') state.equipmentTypeIds = values;
    else if (f.name === 'severityName') state.severityName = values;
    else if (f.name === 'situation') state.situationNames = values;
  });
  return state;
};

/**
 * Tipos e Interfaces compartilhadas entre
 * SideBarFilterAlarms e DesktopFilterAlarms
 */

export interface FilterState {
  equipmentTypeIds: string[];
  severityName: string[];
  situationNames: string[];
}

export interface EquipmentType {
  id: number;
  name: string;
  displayName: string;
  sortPriority: number;
}


export interface AlarmSeverity {
  id: number;
  name: string;
  displayName: string;
  sortPriority: number;
}

/**
 * Opções de Situação (estáticas, não vêm da API)
 */
export interface SituationOption {
  name: "has_alarm_sound" | "active" | "equipment_no_communication" | "not_acknowledged";
  displayName: string;
}

/**
 * Props compartilhadas entre filtros
 */
export interface FilterComponentProps {
  onApplyFilters: (filters: Array<any>, count: number) => void;
  hasClearFilters: boolean;
  initialFilters?: ADataGridFilter[];
  /** Chave do localStorage de onde o estado inicial é hidratado. Padrão: filtros da tela de Alarmes. */
  storageKey?: string;
}

export interface SideBarFilterState {
  loading: boolean;
  saving: boolean;
  errorMessage: string | undefined;
  successMessage: string | undefined;
  equipments: EquipmentType[];
  severities: AlarmSeverity[];
}

/**
 * Contantes para Situações
 */
export const SITUATION_OPTIONS: SituationOption[] = [
  { name: "has_alarm_sound", displayName: "Sonoro" },
  { name: "active", displayName: "Ativo" },
  { name: "equipment_no_communication", displayName: "Sem comunicação" },
  { name: "not_acknowledged", displayName: "Não reconhecido" },
];
